import { commonApi } from '@/common/index';
import { validataNumber, ValidateRequire } from '@/common/utils/validate.js'
import { toStarString } from '@/common/utils/index.js'
import noPayDialog from '../components/no-pay-dialog.vue'
export default {
  components: { noPayDialog },
  data() {
    return {
      noPayshow:false,
      submitLoading: false,
      step: 0,
      payParams: {},
      orderInfo: {},
      paySelected: {}
    }
  },
  created() {
    const { payCode, payViewName, parentCode } = this.$route.query
    this.payParams = { payCode, payViewName, parentCode }
    this._getPayConfig({ payCode }) // 获取支信息
  },
  computed: {
    remarkImg() {
      if (this.paySelected.remarkImg && this.paySelected.remarkImg !== '') {
        return this.$store.state.linkList.staticDomain + this.paySelected.remarkImg
      } else {
        return null
      }
    }
  },
  methods: {
    _getPayConfig(param = {}) { // 获取支付信息
      const params = Object.assign({}, { deviceType: 'mobile', UUID: this.$store.state.UUID }, param)
      commonApi.PAY.getPayConfig(params).then(data => {
        if (data.length > 0) {
          data.forEach((item) => {
            if (item.probability === 0) {
              item.bankAccount = toStarString(item.bankAccount, true)
              item.bankNumber = toStarString(item.bankNumber)
              item.payGate = toStarString(item.payGate, undefined, 1)
            }
          })
          this.paySelected = data[0]
          if (this.bankLists !== undefined) this.bankLists = data
          if (this.payLists !== undefined) this.payLists = data
          this.implementationFetched(data)
        }
        if(data === 202 && this.$store.state.userInfo.depositModel == '1'){
          // 订单存在提示弹框
          this.noPayshow = true;
        }
      }).catch(err => {})
    },
    implementationFetched(data) {}, // 获取数据后续处理
    _submitDeposit(param) { // 提交存款内容
      return new Promise((resolve, reject) =>{
        const params = Object.assign({}, { UUID: this.$store.state.UUID }, param)
        commonApi.PAY.submitDepositInfo(params).then(data => {
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    handeNext() {
      if (!this.checkSubmit()) return
      const params = { ...this.deposit, payId: this.paySelected.id }
      this.submitLoading = true
      this._submitDeposit(params).then(res => {
        this.submitLoading = false
        this.orderInfo = res.order
        if (this.paySelected.probability === 0) {
          const type = this.payParams.parentCode === 'TOBANK_IN'
          if (this.payParams.parentCode === 'TOBANK_IN') {
            this.orderInfo.bankAccount = toStarString(this.orderInfo.bankAccount, true)
          } else {
            this.orderInfo.bankAccount = toStarString(this.orderInfo.bankAccount, undefined, 1)
          }
        }
        this.step++
      }).catch(err => {
        this.$vux.toast.show({ text: err, type: 'warn' })
        this.submitLoading = false
      })
    },
    checkSubmit() { // 验证是否可以提交
      const { amount, payerName, imgUrl } = this.deposit
      const { depositMin, depositMax } = this.paySelected
      if (!validataNumber(amount) || (validataNumber(amount) && (amount * 1 > depositMax || amount * 1 < depositMin))) {
        this.$vux.toast.show({ text: this.$t('Deposit').saveMoneyNumPlace + `${depositMin} ~ ${depositMax}`, type: 'cancel' })
        return
      }
      if (payerName !== undefined && !ValidateRequire(payerName)) {
        this.$vux.toast.show({ text: this.$t('Deposit').orderNamePlace, type: 'cancel' })
        return
      }
      if (!ValidateRequire(imgUrl)) {
        this.$vux.toast.show({ text: this.$t('Deposit').saveCertificatePlace, type: 'cancel' })
        return
      }
      return true
    },
    _setimgUrl(v) {
      this.deposit.imgUrl = v
    },
    _onBlurInteger(e) {
      console.log(e)
    },
    _conactService() { // 联系客服
      let $url = this.$store.state.FrontConfigList.bank_service
	  if ($url === '' || !$url) return
      if ($url.indexOf('http') !== -1) {
        window.open($url, '_bank')
      } else {
        this.$router.replace({ path: $url.replace('#', '') })
      }
      return
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/SaveMonery/mixins/getPayInfo.js